import React, { useState } from "react";
import useTable from "../../../../components/useTable";
import { InfoButton } from "../../../../ui/buttons/Button";
const headCells = [
  {
    id: "nombre",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Nombre",
    textAlign: "center",
  },
  {
    id: "correoElectronico",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Correo Electrónico",
    textAlign: "center",
  },
  {
    id: "status",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Status",
    textAlign: "center",
  },
];

export default function TablaEnvioCorreo(){
  const [tableData, setTableData] = useState([]);
    const [filterFn, setFilterFn] = useState({
      fn: (items) => {
        return items;
      },
    });
  
    const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTable(
      tableData,
      headCells,
      filterFn
    );
  return <div className="col-12 m-0 p-0 d-flex flex-wrap">
    <div className="col-11 m-0 p-0">
      <TblContainer>
        <TblHead />
        <tbody>
          {tableData &&
            recordsAfterPagingAndSorting().map((item, index) => (
              <tr key={index}></tr>
            ))}
        </tbody>
      </TblContainer>
    </div>
    <div className="col-1 m-0 p-0 d-flex gap-2 alingn-items-center justify-content-center">
      <div className="col-auto m-0 p-0">
        <InfoButton icon = 'fa-print m-0' />
      </div>
    </div>
   
  </div>
}